export default "/images/img_11.png?2586a9ca7bc56cf0fcaa36a8ad590911";